import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {CustomerPolicy} from '../organization/customer-policy';
import {GoogleService} from './google-service';

@Service()
export class CustomerPolicyService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getCustomerPolicies(organizationId: string): Observable<CustomerPolicy[]> {
    let url = this.urlBase + 'customerPolicies/organization/' + organizationId;
    return this.http.get<CustomerPolicy[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  public save(policy: CustomerPolicy): Observable<any> {
    let url = this.urlBase + 'customerPolicies/save';
    let body = JSON.stringify(policy);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

}

